export default __webpack_public_path__ + "static/media/404-error-with-astronaut-line-galaxy-background_114341-124.8f3b1fda.jpg";